//auth
export const AUTHENTICATE = 'AUTHENTICATE';
export const LOGOUT = 'LOGOUT';